export default {"src":"/_next/static/media/rap.e9c73998.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};